import { create } from 'zustand';

/**
 * Registry of currently-open full-screen sheets, top-most last. The Android
 * hardware back button (and anything else that needs "dismiss the top
 * overlay" semantics) pops this stack before falling back to router
 * navigation (android-app-plan §6.3 / M2.5).
 */
interface SheetEntry {
  id: number;
  close: () => void;
}

interface SheetStackState {
  entries: SheetEntry[];
  push: (entry: SheetEntry) => void;
  remove: (id: number) => void;
  /** Close the top-most open sheet. Returns true when one was closed. */
  closeTop: () => boolean;
}

export const useSheetStackStore = create<SheetStackState>((set, get) => ({
  entries: [],
  push: (entry) => set((s) => ({ entries: [...s.entries, entry] })),
  remove: (id) => set((s) => ({ entries: s.entries.filter((e) => e.id !== id) })),
  closeTop: () => {
    const { entries } = get();
    const top = entries[entries.length - 1];
    if (!top) return false;
    top.close();
    return true;
  },
}));

let nextSheetId = 1;

/** Stable unique id for a sheet instance. */
export function allocateSheetId(): number {
  nextSheetId += 1;
  return nextSheetId;
}
